import React, { useEffect, useState } from 'react'
import styles from './customer.module.css'
import TextField from "@mui/material/TextField";
import {
  InputLabel,
  Select,
  FormControl,
  MenuItem,
  Link,
  Button,
  FormHelperText,
  InputBase,
} from "@mui/material";
import Head from 'next/head';


export default function Index() {


  const [user, setUser] = useState({})
  const [error, setError] = useState({})
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [open, setOpen] = React.useState(false);

  const handleInput = (e) => {

    let name = e.target.name;
    let value = e.target.value
    if (name === "state") {

      setError({ ...error, [name]: undefined })
    }

    setUser({ ...user, [name]: value })

  }

  // <--------------------------- Phone Formating --------------------------->
  const phoneFormatting = (event) => {
    // console.log("event", event)
    if (event.target.value.split("").length <= 14) {
      let formatted = formatPhoneText(event.target.value);
      let name = event.target.name;
      user.phone = formatted
      setUser({ ...user, [name]: formatted })
    }
  }

  function formatPhoneText(value) {
    value = value.trim().replaceAll("-", "");
    value = value.trim().replaceAll("(", "");
    value = value.trim().replaceAll(")", "");
    value = value.trim().replaceAll(" ", "");

    if (value.length > 3 && value.length <= 6) value = "(" + value.slice(0, 3) + ")" + " " + value.slice(3);
    else if (value.length > 6) value = "(" + value.slice(0, 3) + ")" + " " + value.slice(3, 6) + "-" + value.slice(6);
    return value;
  }

















  useEffect(() => {
    console.log(user)
  }, [user])
  const handleSubmit = async (e) => {
    e.preventDefault()
    let errorObject = {}


    if (!user?.first_name) {
      errorObject.first_name = "First Name is Required"
    }
    if (!user?.email) {
      errorObject.email = "Email is Required"

    }
    else if (!/\S+@\S+\.\S+/.test(user.email)) {
      errorObject.email = '* Invalid email format';
    }
    if (!user?.last_name) {
      errorObject.last_name = "Last Name is Required"
    }
    if (!user?.city) {
      errorObject.city = "City is Required"
    }
    if (!user?.contact_number) {
      errorObject.contact_number = " Telephone Number is Required"
    }

    if (!user?.state) {
      errorObject.state = "State is Required"
    }
    if (!user?.gender) {
      errorObject.gender = "Gender is Required"
    }
    if (!user?.comments) {
      errorObject.comments = "Questions Or Comments is Required"
    }
    if (!user?.zip) {
      errorObject.zip = "Zip is Required"
    }
    if (Object.keys(errorObject).length > 0) {
      setError(errorObject)
      console.log("error exeist");
    }
    else {
      setUser({ ...user, ["contact_number"]: user.contact_number.replace(/^\((.+)\)$/, "") })
      setLoader(true)


      setError({})
      let requestOptions = {
        method: 'POST',
        // mode:'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
      }
      console.log(user)
      try {
        let req = await fetch("https://u7yxpmocqi.execute-api.us-west-1.amazonaws.com/dev/contact/practicelab-contact-add ", requestOptions)
        console.log("req", req);
        let res = await req.json()
        console.log(res);
        setSnackbarStare(true)

      } catch (error) {
        console.log(error, "this is submit error");
        setLoader(false)
      }
      setLoader(false)
      setUser(null)
      console.log("kjhkjh", user)


    }
  }
  const StateArray = [
    {
      name: "Alabama",
      val: "AL",
    },
    {
      name: "Alaska",
      val: "AK",
    },
    {
      name: "Arizona",
      val: "AZ",
    },
    {
      name: "Arkansas",
      val: "AR",
    },
    {
      name: "California",
      val: "CA",
    },
    {
      name: "Colorado",
      val: "CO",
    },
    {
      name: "Connecticut",
      val: "CT",
    },
    {
      name: "Delaware",
      val: "DE",
    },
    {
      name: "Florida",
      val: "FL",
    },
    {
      name: "Georgia",
      val: "GA",
    },
    {
      name: "Hawaii",
      val: "HI",
    },
    {
      name: "Idaho",
      val: "ID",
    },
    {
      name: "Illinois",
      val: "IL",
    },
    {
      name: "Indiana",
      val: "IN",
    },
    {
      name: "Iowa",
      val: "IA",
    },
    {
      name: "Kansas",
      val: "KS",
    },
    {
      name: "Kentucky",
      val: "KY",
    },
    {
      name: "Louisiana",
      val: "LA",
    },
    {
      name: "Maine",
      val: "ME",
    },
    {
      name: "Maryland",
      val: "MD",
    },
    {
      name: "Massachusetts",
      val: "MA",
    },
    {
      name: "Michigan",
      val: "MI",
    },
    {
      name: "Minnesota",
      val: "MN",
    },
    {
      name: "Mississippi",
      val: "MS",
    },
    {
      name: "Missouri",
      val: "MO",
    },
    {
      name: "Montana",
      val: "MT",
    },
    {
      name: "Nebraska",
      val: "NE",
    },
    {
      name: "Nevada",
      val: "NV",
    },
    {
      name: "New Hampshire",
      val: "NH",
    },
    {
      name: "New Jersey",
      val: "NJ",
    },
    {
      name: "New Mexico",
      val: "NM",
    },
    {
      name: "New York",
      val: "NY",
    },
    {
      name: "North Carolina",
      val: "NC",
    },
    {
      name: "North Dakota",
      val: "ND",
    },
    {
      name: "Ohio",
      val: "OH",
    },
    {
      name: "Oklahoma",
      val: "OK",
    },
    {
      name: "Oregon",
      val: "OR",
    },
    {
      name: "Pennsylvania",
      val: "PA",
    },
    {
      name: "Rhode Island",
      val: "RI",
    },
    {
      name: "South Carolina",
      val: "SC",
    },
    {
      name: "South Dakota",
      val: "SD",
    },
    {
      name: "Tennessee",
      val: "TN",
    },
    {
      name: "Texas",
      val: "TX",
    },
    {
      name: "Utah",
      val: "UT",
    },
    {
      name: "Vermont",
      val: "VT",
    },
    {
      name: "Virgin Islands",
      val: "VI",
    },
    {
      name: "Virginia",
      val: "VA",
    },
    {
      name: "Washington",
      val: "WA",
    },
    {
      name: "West Virginia",
      val: "WV",
    },
    {
      name: "Wisconsin",
      val: "WI",
    },
    {
      name: "Wyoming",
      val: "WY",
    },
  ];

  const GenderArray = [
    {
      name: "Male",
      val: "M",
    },
    {
      name: "Female",
      val: "F",
    },
    {
      name: "Others",
      val: "O",
    },
  ];
  return (
    <>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <div className={styles.divine_signup_page_main}>
        <div className={styles.divine_signup_page_cmmn_wdth}>


          <div className={styles.divine_signup_page_main_flx}>

            <div className={styles.divine_signup_page_left}>

              {/* <div className='sign_up_logo_wrpr'>
                <span><img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/sign_up/divine_sign_up_logo.webp"/></span>
                <h1 data-text="SCHOOL OF THE DIVINE">SCHOOL OF THE DIVINE</h1>
                <h1 data-text="SCHOOL OF THE DIVINE">INFINITE BEING</h1>
              </div> */}

              <div className={styles.divine_signup_page_left_top_sec}>

                <div className={styles.divine_signup_page_left_sub_left}>
                  <div className={styles.sign_up_logo_wrpr}>
                    <span><img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/sign_up/divine_sign_up_logo.webp" /></span>
                    <div className={styles.sign_up_logo_txt}><h1 data-text="SCHOOL OF THE DIVINE" >SCHOOL OF THE DIVINE</h1>
                      <h1 data-text="SCHOOL OF THE DIVINE">INFINITE BEING</h1></div>
                  </div>
                </div>

                <div className={styles.divine_signup_page_right_sub_right}>
                  <div className={styles.divine_signup_page_right_sub_right_sub}>
                    <div className={styles.divine_signup_page_right_sub_men}>
                      <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/sign_up/men_img.webp' />
                    </div>
                    <div className={styles.divine_signup_page_right_sub_txt}>
                      <h4>Lorem Ipsum </h4>
                      {/* <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> */}
                      <div className={styles.divine_signup_page_phn_feild}>
                        <p>Lorem Ipsum@simply</p>
                        <p>0000 000 000</p>
                        <p>The printing, and typesetting industry453, Lorem </p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div className={styles.divine_signup_mddl_txt}>

                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. <span> It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</span> </p>
                <p>It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>

              </div>

              <div className={styles.divine_signup_last_sec}>
                <h5>Lorem Ipsum is simply dummy :</h5>
                <div className={styles.divine_signup_last_sec_bullet}>

                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                  <p>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
                  <p>It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>

                </div>

              </div>

            </div>

            <div className={styles.divine_signup_page_right}>

              <div className={styles.divine_signup_page_right_inn}>

                <div className={styles.divine_signup_page_right_form_hdr}>
                  <h2>SIGN UP HERE</h2>
                </div>

                <form>
                  <TextField
                    className={`${styles.from_input} ${styles.form_field_wrapperfname}`}
                    id="outlined-basic"
                    name="first_name"
                    value={user?.first_name ? user.first_name : ""}
                    onChange={handleInput}
                    error={error.first_name ? true : false}
                    helperText={error.first_name}
                    onKeyDown={() => { error.first_name = "" }}

                    // label="Email*"
                    variant="outlined"
                    label="First Name"
                  />
                  <TextField
                    className={`${styles.from_input} ${styles.form_field_wrapperlname}`}
                    id="outlined-basic"
                    name="last_name"
                    value={user?.last_name ? user.last_name : ""}
                    onChange={handleInput}
                    error={error?.last_name ? true : false}
                    helperText={error.last_name}
                    onKeyDown={() => { error.last_name = "" }}
                    // label="Email*"
                    variant="outlined"
                    label="Last Name"
                  />

                  <TextField
                    className={`${styles.from_input} `}
                    id="outlined-basic"
                    name="email"
                    value={user?.email ? user.email : ""}
                    onChange={handleInput}
                    error={error.email ? true : false}
                    helperText={error.email}
                    onKeyDown={() => { error.email = "" }}
                    // label="Email*"
                    variant="outlined"
                    label="Email"
                  />

                  <TextField
                    label="Phone No"
                    className={`${styles.from_input} `}
                    variant="outlined"
                    fullWidth={true}
                    name="contact_number"
                    type="text"
                    onKeyPress={(e) => {
                      error.contact_number = ""
                      // console.log("this is number onkeydown=====", e.code, e.key, 'e.which', e.which);
                      if (e.which < 48 || e.which > 57) {
                        e.preventDefault();
                      }
                      else {
                        let input = e.target.value;
                        let result = input.replace(/\D/g, '');
                        console.log(input, result, "suyagudsa");
                      }
                    }}
                    onChange={(e) => phoneFormatting(e)}
                    value={user?.contact_number}
                    error={error?.contact_number ? true : false}
                    helperText={error?.contact_number}
                  />

                  {/* <TextField
                            label="Gender"
                            className={`${styles.from_input} `}
                            id="outlined-basic"
                            name="gender"
                            value={user?.gender ? user.gender : ""}
                            onChange={handleInput}
                            error={error.gender ? true : false}
                            helperText={error.gender}
                            onKeyDown={() => { error.gender = "" }}
                            label="Email*"
                            variant="outlined"
                           
                            
                          
                          /> */}


                  <FormControl
                    className={`${styles.from_input} ${styles.form_field_wrapperstate}`}
                  >
                    <InputLabel id="demo-simple-select-helper-label">
                      Gender
                    </InputLabel>
                    <Select
                      className="contact_select_menu"
                      id="demo-simple-select-helper"
                      label="Select Gender"
                      name="gender"
                      onChange={handleInput}
                      value={user?.gender ? user?.gender : ""}
                      error={error.gender ? true : false}
                    // value={user.select_taxonomy}
                    // onChange={handleInput}
                    // helperText={error.select_taxonomy}
                    >
                      {GenderArray.map((item, key) => {
                        return (
                          <MenuItem className="contact_menu_item" value={item.val} key={key}>{item.name}</MenuItem>
                        );
                      })}
                    </Select>
                    {error.gender && <FormHelperText id="my-helper-text" >{error.gender}</FormHelperText>}

                  </FormControl>

                  <TextField
                    label="City"
                    className={`${styles.from_input} `}
                    id="outlined-basic"
                    name="city"
                    value={user?.city ? user.city : ""}
                    onChange={handleInput}
                    error={error.city ? true : false}
                    helperText={error.city}
                    onKeyDown={() => { error.city = "" }}
                    // label="Email*"
                    variant="outlined"



                  />


                  {/* <TextField
                          id="outlined-multiline-flexible"
                          label="Massage"
                          name="comments"
                          className={`${styles.from_input} ${styles.form_field_wrappermessage}`}
                          value={user?.comments ? user.comments : ""}
                          onChange={handleInput}
                          error={error.comments ? true : false}
                          helperText={error.comments}
                          onKeyDown={() => {
                            error.comments = "";
                          }}
                          multiline
                          rows={3}
                          maxRows={4}
                        /> */}

                  <FormControl
                    className={`${styles.from_input} ${styles.form_field_wrapperstate}`}
                  >
                    <InputLabel id="demo-simple-select-helper-label">
                      Select State
                    </InputLabel>
                    <Select
                      className="contact_select_menu"
                      id="demo-simple-select-helper"
                      label="Select State"
                      name="state"
                      onChange={handleInput}
                      value={user?.state ? user.state : ""}
                      error={error.state ? true : false}
                    // value={user.select_taxonomy}
                    // onChange={handleInput}
                    // helperText={error.select_taxonomy}
                    >
                      {StateArray.map((item, key) => {
                        return (
                          <MenuItem className="contact_menu_item" value={item.val} key={key}>{item.name}</MenuItem>
                        );
                      })}
                    </Select>
                    {error.state && <FormHelperText id="my-helper-text" >{error.state}</FormHelperText>}

                  </FormControl>

                  <TextField
                    label="Zip"
                    className={`${styles.from_input} `}
                    id="outlined-basic"
                    name="zip"
                    value={user?.zip ? user.zip : ""}
                    onChange={handleInput}
                    error={error.zip ? true : false}
                    helperText={error.zip}
                    onKeyDown={() => { error.zip = "" }}
                    // label="Email*"
                    variant="outlined"



                  />



                  <Button
                    className={`${styles.button} ${styles.submitbtnsection}`}
                    variant="contained" onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </form>

              </div>


            </div>

          </div>
        </div>
      </div>
    </>
  )
}
